import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useAuth } from "../context/AuthContext";

const stripePromise = loadStripe("pk_live_51TblU4L0sA58YoXrYJGrrAlSkBJCgA3p63X3dXAjOEPeSeUkPwPYI1YF11NLSukbHzTzFyuFnUZLRzpaJRlt08MV00TH4KUDPG");

function BNPLForm({ clientSecret, checkoutData, provider, total }) {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
 const [ready, setReady] = useState(false);
const [selectedMethod, setSelectedMethod] = useState(provider);

  const handlePay = async () => {
    if (!stripe || !elements || loading) return;
    setLoading(true);
    setErrorMsg("");

 const fullName = `${checkoutData?.firstName || ""} ${checkoutData?.lastName || ""}`.trim() || "ELEVEN Customer";

const { error } = await stripe.confirmPayment({
  elements,
  confirmParams: {
    return_url: `${window.location.origin}/invoice/pending`,
    payment_method_data: {
      billing_details: {
        name: fullName,
        email: checkoutData?.email || "",
      }
    },
    shipping: {
      name: fullName,
      address: {
        line1: checkoutData?.address || "123 Main St",
        city: checkoutData?.city || "Miami",
        state: checkoutData?.state || "FL",
        postal_code: checkoutData?.zip || "33014",
        country: "US"
      }
    }
  },
  redirect: "if_required"
});

    setLoading(false);

    if (error) {
      setErrorMsg(error.message);
    } else {
      // Payment succeeded without redirect (unlikely for Klarna/Affirm but handle it)
      const piId = clientSecret.split("_secret_")[0];
      navigate(`/invoice/pending?payment_intent=${piId}`);
    }
  };

  const providerLabel = provider === "klarna" ? "Klarna" : "Affirm";
  const providerColor = provider === "klarna" ? "#FFB3C7" : "#0FA0EA";
  const providerTextColor = provider === "klarna" ? "#17120E" : "#fff";

  return (
    <div style={{ maxWidth: 520, margin: "0 auto", padding: "40px 24px", fontFamily: "-apple-system, BlinkMacSystemFont, system-ui" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32 }}>
        <button onClick={() => navigate(-1)} style={{ background: "#f3f4f6", border: "none", borderRadius: 10, padding: "8px 14px", fontSize: 14, fontWeight: 600, cursor: "pointer", color: "#374151" }}>← Back</button>
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, color: "#9ca3af" }}>ELEVEN</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#0f0f17", letterSpacing: -0.5 }}>Pay with {providerLabel}</div>
        </div>
      </div>

      {/* Order total */}
      <div style={{ background: "#fff", borderRadius: 16, padding: "16px 20px", marginBottom: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 14, color: "#6b7280", fontWeight: 500 }}>Order Total</span>
        <span style={{ fontSize: 22, fontWeight: 800, color: "#0f0f17" }}>${Number(total).toFixed(2)}</span>
      </div>

      {/* Payment Element */}
      <div style={{ background: "#fff", borderRadius: 16, padding: "20px", marginBottom: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
      <PaymentElement
          onReady={() => setReady(true)}
          onChange={(e) => { if (e.value?.type) setSelectedMethod(e.value.type); }}
          options={{
            layout: "tabs",
            wallets: { applePay: "never", googlePay: "never" }
          }}
        />
      </div>

      {errorMsg && (
        <div style={{ background: "#FFF0F0", border: "1px solid #FECACA", borderRadius: 12, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: "#DC2626", fontWeight: 500 }}>
          {errorMsg}
        </div>
      )}

      <button
        onClick={handlePay}
        disabled={!ready || loading}
      style={{ width: "100%", padding: "16px", borderRadius: 14, border: "none", background: selectedMethod === "klarna" ? "#FFB3C7" : selectedMethod === "affirm" ? "#0FA0EA" : "#0f0f17", color: selectedMethod === "klarna" ? "#17120E" : "#fff", fontSize: 16, fontWeight: 700, cursor: !ready || loading ? "not-allowed" : "pointer", opacity: !ready || loading ? 0.6 : 1, transition: "all 0.18s ease" }}
      >
        {loading ? "Processing..." : `Pay $${Number(total).toFixed(2)} with ${selectedMethod === "klarna" ? "Klarna" : selectedMethod === "affirm" ? "Affirm" : selectedMethod === "card" ? "Card" : providerLabel}`}
      </button>

      <p style={{ fontSize: 12, color: "#9ca3af", textAlign: "center", marginTop: 12 }}>
        You'll be redirected to {providerLabel} to complete your payment securely.
      </p>

    </div>
  );
}

export default function CheckoutBNPL() {
  const location = useLocation();
  const navigate = useNavigate();
  const { clientSecret, provider, checkoutData, total } = location.state || {};

  useEffect(() => {
    if (!clientSecret) navigate("/checkout");
  }, [clientSecret]);

  if (!clientSecret) return null;

  return (
    <div style={{ background: "#F4F5F7", minHeight: "100vh" }}>
      <Elements
        stripe={stripePromise}
        options={{
          clientSecret,
          appearance: { theme: "stripe" }
        }}
      >
        <BNPLForm
          clientSecret={clientSecret}
          checkoutData={checkoutData}
          provider={provider}
          total={total}
        />
      </Elements>
    </div>
  );
}